import {range} from '@aboutyou/utils';
import {styled} from '@linaria/react';
import React from 'react';
import {SkeletonBlock} from './SkeletonBlock';

interface PlaceholderProps {
  amount?: number;
  className?: string;
}

export const PlaceholderCategoryTree: React.FC<PlaceholderProps> = ({
  amount,
  className,
}) => {
  return (
    <Container className={className}>
      <SkeletonBlock $height={'35px'} $width={'40%'} />
      {range(0, amount ?? 6).map(idx => {
        const width = Math.abs(Math.sin(idx)) * 50 + 50;
        return (
          <Entry key={idx}>
            <SkeletonBlock
              $height={'30px'}
              $width={`${width}%` as `${number}${'%'}`}
            />
          </Entry>
        );
      })}
    </Container>
  );
};

const Container = styled.div`
  padding: 0px 30px;
  max-width: 400px;
`;

const Entry = styled.div`
  margin: 30px;
`;
